import CreditLifeQuote from './CreditLifeQuote'

export default CreditLifeQuote
